import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import '../../assets/styles/Layout.css';

const Layout: React.FC = () => {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <div className="container">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout; 